import PropTypes from "prop-types";

import { MapPinFill } from "@icons";

export function Meta({ address = "" }) {
  return (
    <ul className="flex flex-wrap flex-row gap-x-2 md:gap-x-4 text-sm text-black-300">
      {address && (
        <li className="flex gap-2 items-center">
          <MapPinFill className="text-blue" /> {address}
        </li>
      )}
    </ul>
  );
}

Meta.propTypes = {
  address: PropTypes.string,
};
